<p-toast position="top-right"></p-toast>
<div class="nps-logout-container w-100 h-100">
    <div class="nps-logout w-100 h-100 background-image">
        <div class="nps-container container-fluid w-100">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-6 text-md-center text-center">
                    <img src="assets/images/logo_monex_2.svg">
                </div>
                <div class="col-12 col-md-12 col-lg-6">
                    <div class="your-opinion mt-3 text-center">
                        <p>{{"nps.logoutLabel" | translate}}</p>
                    </div>
                    <div class="w-100" *ngIf="npsService.showNps">
                        <app-nps (onCloseNpsNextQuestion)="closeSession()"
                                 (onCloseNpsSuccess)="closeSession()"
                                 [borderRound]="true" [showCloseIcon]="false"></app-nps>
                    </div>
                    <div class="close-session-container">
                        <a (click)="closeSession()" class="close-session"> {{'CLOSE_SESSION'|translate}} </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
